import { UserRoles } from "@/services";

import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';

import AuthLayout from 'src/pages/Auth/AuthLayout.vue';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

// Dashboard pages
const Dashboard = () =>
    import ( /* webpackChunkName: "dashboard" */ 'src/pages/Dashboard/Dashboard.vue');

import EmptyRouterView from "@/pages/GeneralViews/EmptyRouterView";

const Login = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Auth/Login.vue');
const Logout = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Auth/Logout.vue');
const Register = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Auth/Register.vue');
const ConfirmEmail = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Auth/ConfirmEmail.vue');

// Grants
const Grants = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Grants/Grants.vue');
const GrantFormFill = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/GrantsForms/GrantFormFill.vue');

const EvaluationFormFill = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/EvaluationForms/EvaluationFormFill.vue');

const OngoingApplications = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/OngoingApplications/OngoingApplications.vue');

// Translations
const Translations = () =>
    import ( /* webpackChunkName: "translations" */ 'src/pages/Translations/Translations.vue');
const Languages = () =>
    import ( /* webpackChunkName: "translations" */ 'src/pages/Translations/Languages.vue');

const ForgotPasswordReset = () =>
    import ('src/pages/Auth/ForgotPasswordReset.vue');
const ForgotPassword = () =>
    import ('src/pages/Auth/ForgotPassword.vue');

const Applications = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Applications/Applications.vue');

const UsersManagement = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/UsersManagement/UsersManagement.vue');

const Messaging = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Messaging/Messaging.vue');

const RequestClarifications = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/RequestClarifications/RequestClarifications.vue');
const RequestClarificationsFill = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/RequestClarifications/Fill.vue');

const Reports = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Reports/Reports.vue');
const ReportsEvaluations = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Reports/Evaluations.vue');
const ReportsFinalRanking = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Reports/FinalRanking.vue');
const ReportsEvaluationsGrid = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Reports/EvaluationsGrid.vue');

const UsersManagementViewProfile = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/UsersManagement/ViewProfile.vue');

// Monitoring
const Monitoring = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Monitoring/Monitoring.vue');
const MonitoringEdit = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Monitoring/MonitoringEdit.vue');
const MonitoringReport = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/Monitoring/MonitoringReport.vue');


const PermissionError = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/PermissionError.vue');

// LogMonitoring
const LogMonitoring = () =>
    import ( /* webpackChunkName: "pages" */ 'src/pages/LogMonitoring/LogMonitoring.vue');
const AddMonitoringForm = () =>
    import ( /* webpackChunkName: "pages" */ 'src/components/LogMonitoring/AddMonitoringForm.vue');
const LogMonitoringReports = () =>
    import ( /* webpackChunkName: "pages" */ 'src/components/LogMonitoring/Reports.vue');
const indicatorForm = () =>
    import ( /* webpackChunkName: "pages" */ 'src/components/LogMonitoring/IndicatorForm.vue');
const monitoringForm = () =>
    import ( /* webpackChunkName: "pages" */ 'src/components/LogMonitoring/MonitoringForm.vue');

let authPages = {
    path: '/auth',
    component: AuthLayout,
    redirect: '/auth/login',
    name: 'Authentication',
    meta: {
        public: true,
        onlyWhenLoggedOut: true
    },
    children: [{
            path: 'login',
            name: 'Login',
            component: Login
        },
        {
            path: 'register',
            name: 'Register',
            component: Register
        },
        {
            path: 'register/confirm/email/:token',
            name: 'Register Confirm',
            component: ConfirmEmail,
            meta: {
                public: true,
                onlyWhenLoggedOut: false
            }
        },
        {
            path: 'forgot',
            name: 'Forgot Password',
            component: ForgotPassword
        },
        {
            path: 'password/reset/:token',
            name: 'Reset Password',
            component: ForgotPasswordReset
        }
    ]
};

let userPages = {
    path: '/user',
    name: 'User',
    component: EmptyRouterView,
    children: [{
            path: 'profile',
            name: 'Profile',
            component: () =>
                import ( /* webpackChunkName: "pages" */ 'src/pages/User/UserProfile.vue'),
        },
        {
            path: 'change-password',
            name: 'Change Password',
            component: () =>
                import ( /* webpackChunkName: "pages" */ 'src/pages/User/UserChangePassword.vue'),
        },
        {
            path: 'new-password',
            name: 'Set New Password',
            component: () =>
                import ( /* webpackChunkName: "pages" */ 'src/pages/User/UserNewPassword.vue'),
        },
        {
            path: 'logout',
            name: 'Logout',
            component: Logout
        },
    ]
}

let ongoingApplications = {
    path: '/ongoing-applications',
    component: EmptyRouterView,
    children: [{
        path: '/',
        name: 'Ongoing Applications',
        component: OngoingApplications
    }]
}

let grantsPages = {
    path: '/grants',
    component: EmptyRouterView,
    children: [{
        path: '/',
        name: 'Grants',
        component: Grants
    }]
}

let reportsPages = {
    path: '/reports',
    component: EmptyRouterView,
    meta: {
        permission: [UserRoles.ADMIN, UserRoles.AUDITOR, UserRoles.REGIONAL_ADMIN, UserRoles.EVALUATOR]
    },
    children: [{
            path: '/',
            name: 'Reports',
            component: Reports
        },
        {
            path: 'evaluations',
            name: 'Evaluation Reports',
            component: ReportsEvaluations,
        },
        {
            path: 'final-ranking',
            name: 'Final Ranking Reports',
            component: ReportsFinalRanking,
        },
        {
            path: 'evaluations/grid/:applicationId',
            name: 'Evaluation Grid',
            component: ReportsEvaluationsGrid
        },
    ]
}

let applicationsPage = {
    path: '/applications',
    component: EmptyRouterView,
    meta: {
        permission: [UserRoles.ADMIN, UserRoles.AUDITOR, UserRoles.REGIONAL_ADMIN, UserRoles.EVALUATOR]
    },
    children: [{
        path: '/',
        name: 'Applications',
        component: Applications
    }]
}

let applicationPage = {
    path: '/application',
    name: 'Application',
    component: EmptyRouterView,
    children: [{
            path: 'fill/:grantId/:applicationId/:appversion?',
            name: 'Fill',
            component: GrantFormFill
        },
        {
            path: 'newfill/:grantId/:regionId/:appversion?',
            name: 'NewFill',
            component: GrantFormFill
        },
        {
            path: 'mgfill/:grantId/:applicationId/:conceptStatus?',
            name: 'ConceptFill',
            component: GrantFormFill
        },
        {
            path: 'evaluate/:evaluationTypeNickname/:applicationId/:evaluationUserId?',
            name: 'Evaluate',
            component: EvaluationFormFill
        },
        {
            path: 'view/:applicationId',
            name: 'View Application',
            component: GrantFormFill
        }
    ]
}

let messagingPage = {
    path: '/messaging',
    component: EmptyRouterView,
    meta: {
        permission: [UserRoles.ADMIN]
    },
    children: [{
        path: '/',
        name: 'Messaging',
        component: Messaging,
    }]
}

let requestsPage = {
    path: '/clarifications',
    component: EmptyRouterView,
    children: [{
            path: '/',
            component: RequestClarifications,
        },
        {
            path: 'fill/:applicationId',
            component: RequestClarificationsFill,
        }
    ]
}

let usersManagementPage = {
    path: '/users-management',
    component: EmptyRouterView,
    meta: {
        permission: [UserRoles.ADMIN, UserRoles.AUDITOR, UserRoles.REGIONAL_ADMIN, UserRoles.EVALUATOR]
    },
    children: [{
            path: '/',
            name: 'Users Management',
            component: UsersManagement,
            meta: {
                permission: [UserRoles.ADMIN]
            },
        },
        {
            path: 'view-profile/:userId',
            name: 'View Profile',
            component: UsersManagementViewProfile,
        }
    ]
}

let translationsPage = {
    path: '/translations',
    redirect: '/translations/translations',
    component: EmptyRouterView,
    meta: {
        permission: [UserRoles.ADMIN]
    },
    children: [{
            path: 'translations',
            name: 'Translations',
            component: Translations
        },
        {
            path: 'languages',
            name: 'Languages',
            component: Languages
        }
    ]
}

let monitoringPage = {
    path: '/monitoring',
    component: EmptyRouterView,
    // meta:
    // {
    //     permission: [UserRoles.ADMIN]
    // },
    children: [{
            path: '/',
            name: 'Monitoring',
            component: Monitoring,
        },
        {
            path: 'edit/:grantId/:applicationId',
            name: 'Edit Monitoring',
            component: MonitoringEdit
        },
        {
            path: 'report/:grantId/:applicationId/:reportId/:key',
            name: 'Monitoring Report',
            component: MonitoringReport
        }
    ],
}
let logMonitoringPage = {
    path: '/logmonitoring',
    component: LogMonitoring,
    redirect: '/logmonitoring/indicatorForm',
    // meta:
    // {
    //     permission: [UserRoles.ADMIN]
    // },
    children: [{
            path: 'indicatorForm',
            name: 'Indicator Form',
            component: indicatorForm
        },
        {
            path: 'addMonitoringForm',
            name: 'Add Monitoring Form',
            component: AddMonitoringForm
        },
        {
            path: 'reports',
            name: 'Reports',
            component: LogMonitoringReports
        },
        {
            path: 'MonitoringForm',
            name: 'Monitoring Form',
            component: monitoringForm,
            // children: [{
            //     path: 'add',
            //     name: 'Add Monitoring Form',
            //     component: AddMonitoringForm,
            // }]
        }
    ],
}

const routes = [{
        path: '/',
        redirect: '/dashboard',
        name: 'Home'
    },
    authPages,
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/dashboard',
        name: 'Dashboard layout',
        children: [{
                path: 'dashboard',
                name: 'Dashboard',
                component: Dashboard,
            },
            userPages,
            ongoingApplications,
            applicationsPage,
            applicationPage,
            grantsPages,
            reportsPages,
            translationsPage,
            usersManagementPage,
            messagingPage,
            requestsPage,
            monitoringPage,
            logMonitoringPage
        ]
    },
    { path: '/permission-error', component: PermissionError },
    { path: '*', component: NotFound },
];

export default routes;